define(['angular', '../module'], function(angular, MODULE_NAME) {
    'use strict';

    var SERVICE_NAME = '$ilmnUiSessionTracker';

    angular.module(MODULE_NAME)
        .provider(SERVICE_NAME, SessionTracker);

    function SessionTracker() {
        var platformApiBaseurl;

        service.$inject = ['$log', '$http'];
        return {
            setPlatformBaseurl: setPlatformBaseurl,
            $get: service
        };

        function service($log, $http) {
            return {
                isIdle: isIdle
            };

            function isIdle() {
                var url = platformApiBaseurl + '/SessionTracker/IsIdle';
                return $http.get(url);
            }
        }

        function setPlatformBaseurl(baseurl) {
            platformApiBaseurl = baseurl;
        }
    }

    return SERVICE_NAME;
});



//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-idle/scripts/sessionTracker.service.js
// module id = 46
// module chunks = 0 1